import { Box, Button, CircularProgress, Divider, IconButton, TextField, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VarianComponent from "../component/varian-item-component";
import { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import AddonComponent from "../component/addon-item-component";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CatatanComponent from "../component/note-item-component";

const EditVarianModal = ({ item, handleCloseFunc }) => {
  const varianRef = useRef(null);

  // State definition  
  const [dataVarian, setDataVarian] = useState({});
  const [dataAddon, setDataAddon] = useState({});
  // const [price, setPrice] = useState(item?.price || 0);
  const [basePrice, setBasePrice] = useState(item?.price || 0);
  const [addonTotal, setAddonTotal] = useState(0);
  const [varianTotal, setVarianTotal] = useState(0);
  const [addon, setAddon] = useState([]);
  const [varian, setVarian] = useState([]);
  const [note, setNote] = useState("");
  const [qty, setqty] = useState(1);
  const [loading, setLoading] = useState(true);
  const [varianError, setVarianError] = useState(false);

  // Fungsi untuk menambahkan item
  const storeItem = () => {   
    const requiredTypes = Object.keys(groupedVarian || {});

    const missing = requiredTypes.filter(
      (type) => !varian.some((v) => v.type === type)
    );

    if (missing.length > 0) {
      setVarianError(true);

      setTimeout(() => {
        varianRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }, 100);
      
      return;
    }

    // Create object untuk order
    let parsed_addon = JSON.parse(localStorage.getItem("addon_data")) || addon;
    let parsed_varian =
      JSON.parse(localStorage.getItem("varian_data")) || varian;
    let parsed_note = localStorage.getItem("note_data") || note;
    let parsed_savedReservation = JSON.parse(localStorage.getItem("reservationData")) || {};    

    let order_arr = [];
    order_arr = JSON.parse(localStorage.getItem("orders")) || [];    

    // let augment = [...parsed_addon, parsed_varian];
    let augment = [
      ...parsed_varian,
      ...parsed_addon,      
      { note: parsed_note }
    ];

    let orderObj = {};
    orderObj[item.sku_id] = {
      tmp_id: order_arr.length + 1,
      order_person: parsed_savedReservation?.order_person,
      order_date: parsed_savedReservation?.order_date,
      outletId: parsed_savedReservation?.outletId,
      phone: `+62${parsed_savedReservation?.phone}`,
      seat: parsed_savedReservation?.seat,
      pack: parsed_savedReservation?.pack,
      address: parsed_savedReservation?.address,
      type: parsed_savedReservation?.type,
      order_detail: augment,
      brand: item.brand,
      product_name: item.name,
      category: item.category,
      subtotal: totalUnitPrice,
      qty: qty,      
    };

    order_arr.push(orderObj);
    localStorage.setItem("orders", JSON.stringify(order_arr));
    localStorage.removeItem("varian_data");
    localStorage.removeItem("addon_data");
    localStorage.removeItem("note_data");     

    // Close modal
    handleCloseFunc();
  };

  // const storeItem = () => {   
  //   const requiredTypes = Object.keys(groupedVarian || {});

  //   const missing = requiredTypes.filter(
  //     (type) => !varian.some((v) => v.type === type)
  //   );

  //   if (missing.length > 0) {
  //     setVarianError(true);

  //     setTimeout(() => {
  //       varianRef.current?.scrollIntoView({
  //         behavior: "smooth",
  //         block: "center"
  //       });
  //     }, 100);
      
  //     return;
  //   }

  //   let parsed_addon = JSON.parse(localStorage.getItem("addon_data")) || addon;
  //   let parsed_varian =
  //     JSON.parse(localStorage.getItem("varian_data")) || varian;
  //   let parsed_note = localStorage.getItem("note_data") || note;
  //   let parsed_savedReservation =
  //     JSON.parse(localStorage.getItem("reservationData")) || {};    

  //   let order_arr = JSON.parse(localStorage.getItem("orders")) || [];    

  //   let augment = [
  //     ...parsed_varian,
  //     ...parsed_addon,      
  //     { note: parsed_note }
  //   ];

  //   const varianObj = parsed_varian.find(v => v.varian_id);

  //   const addonSignature = parsed_addon
  //     .map(a => a.addon_id)
  //     .sort()
  //     .join("|");

  //   const signature = JSON.stringify({
  //     product_name: item.name,
  //     brand: item.brand,
  //     varian_id: varianObj?.varian_id || null,
  //     addons: addonSignature
  //   });

  //   let merged = false;

  //   order_arr = order_arr.map((obj) => {
  //     const key = Object.keys(obj)[0];
  //     const data = obj[key];

  //     const oldVarian = data.order_detail.find(d => d.varian_id);

  //     const oldAddonSignature = data.order_detail
  //       .filter(d => d.addon_id)
  //       .map(d => d.addon_id)
  //       .sort()
  //       .join("|");

  //     const oldSignature = JSON.stringify({
  //       product_name: data.product_name,
  //       brand: data.brand,
  //       varian_id: oldVarian?.varian_id || null,
  //       addons: oldAddonSignature
  //     });

  //     if (oldSignature === signature) {
  //       data.qty += qty;
  //       data.subtotal += totalUnitPrice;
  //       merged = true;
  //     }

  //     return obj;
  //   });

  //   if (!merged) {
  //     let orderObj = {};
  //     orderObj[item.sku_id] = {
  //       tmp_id: order_arr.length + 1,
  //       order_person: parsed_savedReservation?.order_person,
  //       order_date: parsed_savedReservation?.order_date,
  //       outletId: parsed_savedReservation?.outletId,
  //       phone: `+62${parsed_savedReservation?.phone}`,
  //       seat: parsed_savedReservation?.seat,
  //       pack: parsed_savedReservation?.pack,
  //       address: parsed_savedReservation?.address,
  //       type: parsed_savedReservation?.type,
  //       order_detail: augment,
  //       brand: item.brand,
  //       product_name: item.name,
  //       category: item.category,
  //       subtotal: totalUnitPrice,
  //       qty: qty,      
  //     };

  //     order_arr.push(orderObj);
  //   }

  //   localStorage.setItem("orders", JSON.stringify(order_arr));
  //   localStorage.removeItem("varian_data");
  //   localStorage.removeItem("addon_data");
  //   localStorage.removeItem("note_data");     

  //   handleCloseFunc();
  // };

  // Fungsi mengambil data addon
  const getAddon = (up) => {
    if (!up) return;

    let parsed = [];
    try {
      parsed = JSON.parse(localStorage.getItem("addon_data")) || [];
    } catch {
      parsed = [];
    }

    const totalAddon = Array.isArray(parsed)
      ? parsed.reduce((acc, ele) => {
          const price = Number(ele?.addon_price);
          return acc + (Number.isFinite(price) ? price : 0);
        }, 0)
      : 0;

    setAddonTotal(totalAddon);
    setAddon(parsed);
  };

  // Fungsi mengambil data varian
  const getVarian = (up) => {
    if (!up) return;

    let parsed = [];
    try {
      parsed = JSON.parse(localStorage.getItem("varian_data")) || [];
    } catch {
      parsed = [];
    }

    const totalVarian = Array.isArray(parsed)
      ? parsed.reduce((acc, ele) => {
          const price = Number(ele?.varian_price);
          return acc + (Number.isFinite(price) ? price : 0);
        }, 0)
      : 0;

    setVarianTotal(totalVarian);
    setVarian(parsed);
  };

  // Fungsi mengambil data catatan
  const getNote = (up) => {
    if (up) {
      let dataNote = localStorage.getItem("note_data");
      setNote(dataNote || "");
    }
  };

  // ===== Use effect function ====
  useEffect(() => {
    setLoading(true)
    // Get varians
    axios({
      method: "get",
      url: `https://script.google.com/macros/s/AKfycbwMR-2Dk9gpd5_KlmhL1Lgk_opPU6OOzb-KJQjizlRtYpKtX_Bp7QWa4i172CDKoRbE/exec?api=varian`,          
    })
    .then((response) => {
      const rawData = response.data;
      setDataVarian(rawData.data);      
    })
    .catch((err) => {})
    .finally(() => {
      setLoading(false)
    }); 

    // Get addon
    axios({
      method: "get",
      url: `https://script.google.com/macros/s/AKfycbwMR-2Dk9gpd5_KlmhL1Lgk_opPU6OOzb-KJQjizlRtYpKtX_Bp7QWa4i172CDKoRbE/exec?api=addon`,           
    })
    .then((response) => {
      const rawData = response.data;      
      setDataAddon(rawData.data);
    })
    .catch((err) => {});
  }, []);  

  const groupedVarian = useMemo(() => {
    if (!Array.isArray(dataVarian) || !item?.brand || !item?.sku_id) return {};

    const filtered = dataVarian.filter((varian) => {
      // const matchBrand =
      //   varian.brand === item.brand ||
      //   (varian.brand === "all" && item.brand !== "minuman");

      const brandList = varian.brand
        ? varian.brand.split(",").map(v => v.trim())
        : [];        
            
      const matchBrand =
        !varian.brand ||
        (brandList.includes("all") && item.brand !== "minuman") ||
        brandList.includes(item.brand);

      const matchSku = !varian.sku_id
        ? true
        : varian.sku_id
            .split(",")
            .map(v => v.trim())
            .includes(item.sku_id);

      return matchBrand && matchSku;
    });

    return filtered.reduce((acc, varian) => {
      const type = varian.type;

      if (!acc[type]) {
        acc[type] = {
          list: [],
          max: varian.max_varian
        };
      }

      acc[type].list.push(varian);

      return acc;
    }, {});
  }, [dataVarian, item?.brand, item?.sku_id]);

  // const groupedAddon = useMemo(() => {
  //   if (!Array.isArray(dataAddon) || !item?.brand) return {};  

  //   const filtered = dataAddon.filter(
  //     (addon) =>
  //       addon.brand === item.brand ||
  //       (addon.brand === "all" && item.brand !== "minuman")
  //   );

  //   const sorted = filtered.sort((a, b) => {
  //     if (a.brand === "all" && b.brand !== "all") return 1;
  //     if (a.brand !== "all" && b.brand === "all") return -1;
  //     return 0; 
  //   });

  //   return sorted.reduce((acc, addon) => {
  //     const type = addon.addon_type;

  //     if (!acc[type]) {
  //       acc[type] = {
  //         list: [],
  //         max: addon.max_addon
  //       };
  //     }

  //     acc[type].list.push(addon);

  //     return acc;
  //   }, {});
  // }, [dataAddon, item?.brand]);

  const groupedAddon = useMemo(() => {
    if (!Array.isArray(dataAddon) || !item?.brand) return {};

    const matchByList = (source, target) => {
      if (!source) return true;

      const list = source
        .split(",")
        .map(v => v.trim());

      return (
        list.includes(target) ||
        (list.includes("all") && target !== "minuman")
      );
    };

    const filtered = dataAddon.filter(addon =>
      matchByList(addon.brand, item.brand)
    );

    const sorted = filtered.sort((a, b) => {
      const aList = a.brand?.split(",").map(v => v.trim()) || [];
      const bList = b.brand?.split(",").map(v => v.trim()) || [];

      const aAll = aList.includes("all");
      const bAll = bList.includes("all");

      if (aAll && !bAll) return 1;
      if (!aAll && bAll) return -1;
      return 0;
    });

    return sorted.reduce((acc, addon) => {
      const type = addon.addon_type;

      if (!acc[type]) {
        acc[type] = {
          list: [],
          max: addon.max_addon
        };
      }

      acc[type].list.push(addon);

      return acc;
    }, {});
  }, [dataAddon, item?.brand]);

  const totalUnitPrice = basePrice + addonTotal + varianTotal;

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "49.5%",          
          transform: "translate(-50%, -50%)",
          width: 350,
          maxHeight: "80%",
          bgcolor: "white",
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          overflowY: "scroll",          
        }}
      >
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          gap={2}
        >
          <IconButton onClick={handleCloseFunc}>
            <ArrowBackIcon />
          </IconButton>
          <Typography fontSize="1em" fontWeight={700}>
            Custom Pembelian
          </Typography>
        </Box>

        <Box
          width="100%"
          display="flex"
          flexDirection="row"
          alignItems="stretch"
          justifyContent="space-between"
        >
          <Box maxWidth="60%">
            <Typography
              fontSize="1em"
              my={1}
              fontWeight={700}
              textOverflow="clip"
            >
              {item.name}
            </Typography>
          </Box>
          <Typography fontSize="1em" my={1} fontWeight={700}>
            {new Intl.NumberFormat("id-ID", {
              style: "currency",
              currency: "IDR",
              minimumFractionDigits: 0,
            }).format(item.price)}
          </Typography>
        </Box>       

        {/* Varian */}
        {loading ? (
          <Box display="flex" justifyContent="center" my={2}>
            <CircularProgress size={24} />
          </Box>
        ) : Object.keys(groupedVarian).length > 0 ? (
          <div ref={varianRef}>
            {Object.keys(groupedVarian).map((variantKey) => {
              const variant = groupedVarian[variantKey];              

              return (
                <>
                  <Divider />
                  <Typography
                    fontSize="1em"
                    fontWeight={700}
                    textTransform="capitalize"
                    my={1}
                  >
                    {variantKey} (Wajib Pilih)
                    <Typography variant="subtitle2">
                      maximum pilih {variant.max}
                    </Typography>
                  </Typography>

                  <VarianComponent
                    max_var={variant.max}
                    list={variant.list}
                    add_func={(up) => getVarian(up)}
                  />
                </>
              );
            })}
          </div>
        ) : (
          <div />
        )}

        {varianError && (
          <Typography color="error" fontSize=".75em" mt={1}>
            * Varian wajib dipilih
          </Typography>
        )}

        <br />

        {/* Addon */}
        {Object.keys(groupedAddon).length > 0 ? (
          <div key={groupedAddon}>
            {Object.keys(groupedAddon).map((addo) => {              
              return (
                <>
                  <Divider />
                  <Typography
                    fontSize="1em"
                    fontWeight={700}
                    textTransform="capitalize"
                    my={1}
                  >
                    {addo.replace(/_/g, " ")} (Optional)
                    <Typography variant="subtitle2">
                      maximum pilih {groupedAddon[addo].max}
                    </Typography>
                  </Typography>

                  <AddonComponent
                    max_var={groupedAddon[addo].max}
                    list={groupedAddon[addo].list}
                    add_func={(up) => getAddon(up)}
                  />
                </>
              );
            })}
          </div>
        ) : (
          <div></div>
        )}

        <br />

        {/* Catatan */}
        <CatatanComponent add_func={(up) => getNote?.(up)} />

        <br />

        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="body1" fontWeight={700}>
            Jumlah Pembelian
          </Typography>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
          >
            <IconButton
              size="small"
              onClick={() => {
                setqty((prev) => (prev - 1 <= 1 ? 1 : prev - 1));
              }}
            >
              <RemoveCircleIcon color="primary" width="1em" />
            </IconButton>
            <Typography
              fontSize={{ xs: ".9em", sm: ".9em", md: "1em", lg: "1em" }}
              sx={{
                fontWeight: 700,
              }}
            >
              {qty}
            </Typography>
            <IconButton
              size="small"
              onClick={() => {
                setqty((prev) => prev + 1);
              }}
            >
              <AddCircleIcon color="primary" width="1em" />
            </IconButton>
          </Box>
        </Box>
        <br />
        <Button fullWidth variant="contained" onClick={storeItem}>
          {qty * totalUnitPrice} - Tambah pembelian
        </Button>
      </Box>
    </>
  );
};

export default EditVarianModal;
